export default {
    db: 'mongodb://127.0.0.1:27017/chat_s42_matthews?authSource=admin',
    demo: false,
    brand: 'Epoints', // Footer brand
    urlBrand: 'https://epoints.vn/',
    appName: 'Matthewsliquor', // App Name
    showCredits: true, // Show credits in login page
    // url: 'http://localhost:4000',
    url: 'https://chat.dev.matthewsliquor.com.au',
    // url: 'https://chat-matthewsliquor.epoints.vn',
    port: 4000
};
